import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NotificationType } from '../model/notification-type';
import {SimpleErrorDialogComponent} from '../components/simple-error-dialog/simple-error-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

@Injectable()
export class NotificationService {

  constructor(public _snackBar: MatSnackBar,
              public _dialog: MatDialog) { }

  /**
   * Show success notification
   * @param message The message to show
   */
  success(message: string) {
    this._show(message, NotificationType.SUCCESS);
  }

  /**
   * Show info notification
   * @param message The message to show
   */
  info(message: string) {
    this._show(message, NotificationType.INFO);
  }

  /**
   * Show a warning notification
   * @param message The message to show
   */
  warning(message: string) {
    this._show(message, NotificationType.WARNING);
  }

  /**
   * Show an error dialog
   * @param message The message to show
   */
  error(message: string) {
    this._dialog.open(SimpleErrorDialogComponent, {
      data: {message: message},
      width: '500px',
      autoFocus: false
    });
  }

  /**
   * Show an error notification
   * @param message The message to show
   */
  errorNotification(message: string) {
    this._show(message, NotificationType.ERROR);
  }

  /**
   * Show a notification
   * @param message The message to show
   * @param type The type of the notification {@see NotificationType}
   * @private
   */
  _show(message: string, type: string) {
    const options: any = environment.ui.snackbar;
    options.panelClass = ['notification', type];

    this._snackBar.open(message, '', options);
  }

  /**
   * Checks if the error message is available to display
   * @param error The error object from the backend response
   */
  checkForErrorMessage(error: any) {
    return error && error.error && error.error.errorMessage;
  }

}
